import axiosInstance from 'src/utils/axios';
import { useQuery } from '@tanstack/react-query';
import {
  SOCIAL_MANAGER_CONTENT_LIST,
  SOCIAL_MANAGER_CONTENT_TYPE_LIST,
  SOCIAL_MANAGER_CONTENT_TYPES_STATUS,
} from 'src/constants/queryKeys';

export const networkCreateSocialManagerContent = async (socialManagerContent) => {
  const res = await axiosInstance.post('/SocialManagerContent/Insert', socialManagerContent);
  return res;
};

export const networkUpdateSocialManagerContent = async (id, socialManagerContent) => {
  const res = await axiosInstance.post(`/SocialManagerContent/Update/${id}`, socialManagerContent);
  return res;
};

export const networkRemoveSocialManagerContent = async (id) => {
  const res = await axiosInstance.post(`/SocialManagerContent/Remove/${id}`);
  return res;
};

export const networkInfoSocialManagerContent = async (id) => {
  const res = await axiosInstance.post(`/SocialManagerContent/Info/${id}`);
  return res;
};

export const networkGetListSocialManagerContent = async (payload, pageIndex, pageSize) => {
  const res = await axiosInstance.post(`/SocialManagerContent/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchSocialManagerContentList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [SOCIAL_MANAGER_CONTENT_LIST, pageIndex, pageSize],
    queryFn: () => networkGetListSocialManagerContent(payload, pageIndex, pageSize),
  });
}

export const networkGetListTypeSocialManagerContent = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`/SocialManagerContentType/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchSocialManagerContentTypeList(payload, pageIndex, pageSize) {
  return useQuery({
    queryKey: [SOCIAL_MANAGER_CONTENT_TYPE_LIST, pageIndex, pageSize],
    queryFn: () => networkGetListTypeSocialManagerContent(payload, pageIndex, pageSize),
  });
}

export const networkGetStatusTypesSocialManagerContent = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`SocialManagerContentStatusType/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchSocialManagerContentTypeStatus(payload, pageIndex, pageSize) {
  return useQuery({
    queryKey: [SOCIAL_MANAGER_CONTENT_TYPES_STATUS, pageIndex, pageSize],
    queryFn: () => networkGetStatusTypesSocialManagerContent(payload, pageIndex, pageSize),
  });
}
